/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { t } from 'ttag';
import * as Sentry from '@sentry/react';

import client from '../../utils/client';

import './genericPopup.less';

const GenericPopup = props => {
  const [infoContent, setInfoContent] = useState('');

  useEffect(() => {
    if (props.type === 'policy') {
      client
        .get(`/policies/${props.name}`)
        .then(res => {
          setInfoContent(res.data);
        })
        .catch(error => {
          Sentry.captureException(error);
        });
    }
  }, []);

  let content = (
    <div className="content" id="contentWrapper">
      {props.children ? (
        props.children
      ) : (
        <>
          <h3 className="extraTitle">{props.otherTitle}</h3>
          <span>{props.otherContent}</span>
        </>
      )}
    </div>
  );
  if (props.type === 'policy') {
    content = (
      <p
        className="content"
        id="contentWrapper"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: infoContent || props.otherContent }}
      />
    );
  }
  if (props.type === 'usp') {
    content = (
      <div className="content" id="contentWrapper">
        <h3 className="extraTitle">{props.otherTitle}</h3>
        <span
          dangerouslySetInnerHTML={{
            __html: infoContent || props.otherContent
          }}
        />
      </div>
    );
  }

  const comp = (
    <div className="ludicrous-popup">
      <div
        className="overlay"
        onClick={() => props.closeModal(false)}
        role="button"
        tabIndex="0"
        style={{ outline: 'none' }}
        aria-label={t`Close Popup`}
      />
      <div className="modal">
        <div className="headerWrapper">
          <div className="header">
            <div className="titleWrapper--show" />
            <div
              className="btnCloseWrapper"
              onClick={() => props.closeModal(false)}
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
            >
              <span className="icon-close-button icon-close-button-dims" />
            </div>
          </div>
        </div>
        {content}
      </div>
    </div>
  );
  return ReactDOM.createPortal(comp, document.querySelector(props.target));
};

export default GenericPopup;
